/* Stylesheet */

.info_message {
  margin: 0px 0px 52px 0px;

  span {
    font-weight: 600;
  }
}
